import s from './remove-appointment.module.scss'
import { Modal } from '@shared/ui/modal/modal';
import { Button } from '@shared/ui/button/button';
import { useRemoveAppointmentModal } from '../../model/use-remove-appointment-modal';
import { useRemoveAppointment } from '../../api/useRemoveAppointment';

export const RemoveAppointmentModal = () => {
	const {isOpen, close, modalParams} = useRemoveAppointmentModal()
	
	const appointmentId = modalParams?.appointmentId
	
	const { mutate: remove } = useRemoveAppointment()
	
	const cancelAppointment = () => {
		remove({id: appointmentId, reason: 'Reason'})
		close()
	}

  return (
		<Modal {...{isOpen, close}}>
			<div className={s.card}>
					<div className={s.title}>Вы уверены?</div>
					<div className={s.text}>Вы точно хотете отменить занятие?</div>
					<div className={s.btns}>
						<Button
							theme='secondary'
							className={s.btn}
							onClick={() => close()}
							label={'Нет'}
						/>
						<Button
							className={s.btn}
							onClick={cancelAppointment}
							label={'Да'}
						/>
					</div>
			</div>
		</Modal>
  );
};